import { useForms } from '@visma/formula';
import ItemsList from 'components/ItemsList';
import { path } from 'components/Routes/forms/form';

export default function FormsList({ filter, ...params }) {
  return <ItemsList itemPath={path} items={useForms(params)} filter={filter} />;
}
